<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        @search="fetchOptionsDebounced"
        @open="fetchOptions($attrs.value)"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på kund</em>
        </template>

        <!-- pass through scoped slots -->
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>

        <!-- pass through normal slots -->
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
            <slot :name="slotName" />
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import debounce from 'lodash/debounce';
import apiClient from '@services/ApiClient';

export default {
    name: 'CardSerieFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        orderId: {
            type: Number,
            default: null,
        },
        onlySeries: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            options: [],
            fetchOptionsDebounced: debounce((search) => {
                this.fetchOptions(search);
            }, 200),
        };
    },
    created() {
        this.fetchOptions(this.$attrs.value);
    },
    beforeUnmount() {
        this.fetchOptionsDebounced.cancel();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async fetchOptions(search = '') {
            await apiClient.get('/vue/cardseries?per_page=100&search=' + search + (this.orderId > 0 ? '&order_id=' + this.orderId : '') + (this.onlySeries ? '&only_series=1' : ''))
                .then((response) => {
                    this.options = response.data.data.map((item) => ({
                        id: item.CardSeriesID,
                        label: item.CardSeriesID + ' - ' + item.SeriesName,
                        ...item,
                    }));
                });
        },
    },
};
</script>
